import React from 'react';
import { useCMSSettings } from '../hooks/useCMSSettings';

export const MaintenancePage = () => {
  const { settings } = useCMSSettings();
  
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="w-24 h-24 bg-gradient-to-tr from-amber-500 to-amber-700 rounded-full mx-auto flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(245,158,11,0.3)]">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
            <path d="M12 9v4"/>
            <path d="M12 17h.01"/>
          </svg>
        </div>
        
        <h1 className="text-3xl font-bold bg-gradient-to-r from-amber-200 to-amber-500 bg-clip-text text-transparent">
          {settings?.site_name || 'Obsidian Web Labs'}
        </h1>
        
        <h2 className="text-xl font-medium text-white/90">
          Under Maintenance
        </h2>
        
        <p className="text-white/60">
          {settings?.maintenance_message || 'We are currently performing scheduled maintenance. We will be back online shortly. Thank you for your patience.'}
        </p>
      </div>
    </div>
  );
};
